import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpUtils } from 'app/core/utils/http-utils';
import { Observable } from 'rxjs';
import { ApplicationConfigService } from 'app/core/config/application-config.service';
import { Extrato } from 'app/shared/model/extrato.model';

interface QueryParams {
  [key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class ExtratoService {

    resourceUrl = this.applicationConfigService.getEndpointFor('/sfz-sped-api-v2/api/v1/extrato-processamento');

    constructor(
      protected http: HttpClient,
      protected applicationConfigService: ApplicationConfigService
    ) {}

    validar(req?: QueryParams): Observable<Extrato> {
      const params = HttpUtils.buildHttpParams(req ?? {});
      return this.http.get<Extrato>(this.resourceUrl + "/validar", { params});
    }

}
